import CloseIcon from '@/common/assets/icons/closeCircleIcon.svg?react';
import { InputAttachmentType } from '@/common/components/base/input/base/CommonInput.type.ts';
import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';

const formResetAttachment = ({
  onReset,
  renderCondition,
}: {
  onReset: () => void;
  renderCondition?: boolean;
}): InputAttachmentType => {
  return createAttachment({
    shouldRender: renderCondition ?? true,
    element: <CloseIcon onClick={onReset} />,
    size: 'small',
  });
};
export default formResetAttachment;
